<template>
  <v-container>
    <v-alert v-if="error" type="error" dismissible @click:close="error = null">
      {{ error }}
    </v-alert>

    <div class="actions" style="display: flex">
      <v-spacer> </v-spacer>
      <v-btn
        @click="openImportModal"
        class="mb-4 mr-2"
        title="Import goals from ProBim Explorer JSON"
      >
        <v-icon left>mdi-file-import</v-icon>
        Import Goals
      </v-btn>
      <v-btn color="primary" @click="openAddModal" class="mb-4">
        <v-icon left>mdi-plus-circle</v-icon>
        Add Goal
      </v-btn>
    </div>

    <!-- Empty State -->
    <div v-if="goals.length === 0 && !loading" class="empty-state">
      <v-icon size="80" color="primary">mdi-target</v-icon>
      <h3>No Goals Yet</h3>
      <p>Create or import goals to define the problem objectives</p>
    </div>

    <GoalsList
      v-else
      :goals="goals"
      :selectedProblem="selectedProblem"
      :loading="loading"
      @goal-updated="fetchGoals"
      @goal-deleted="fetchGoals"
      @edit-goal="openEditModal"
    />

    <GoalModal
      :isOpen="showModal"
      :selectedProblem="selectedProblem"
      :editingGoal="editingGoal"
      @goal-saved="onGoalSaved"
      @close="closeModal"
    />

    <!-- Import Goals Modal -->
    <ImportGoalsModal
      :value="showImportModal"
      :existing-goals="goals"
      :selected-problem="selectedProblem"
      @close="showImportModal = $event"
      @goals-imported="onGoalsImported"
    />
  </v-container>
</template>

<script>
import GoalsList from "./GoalsList.vue";
import GoalModal from "./GoalModal.vue";
import ImportGoalsModal from "./ImportGoalsModal.vue";
import apiClient from "@/plugins/apiService";

export default {
  components: {
    GoalsList,
    GoalModal,
    ImportGoalsModal,
  },
  props: {
    selectedProblem: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      goals: [],
      showModal: false,
      showImportModal: false,
      editingGoal: null,
      error: null,
      loading: false,
    };
  },
  mounted() {
    this.fetchGoals();
  },
  watch: {
    selectedProblem() {
      this.fetchGoals();
    },
  },
  methods: {
    fetchGoals() {
      this.loading = true;
      this.error = null;
      apiClient
        .get(`/goal/${this.selectedProblem}`)
        .then((response) => {
          const data = response.data;
          if (data.error) {
            this.error = data.error;
            this.goals = [];
          } else {
            this.goals = data.map((goal) => ({ ...goal, editing: false }));
          }
        })
        .catch((error) => {
          this.error = `Error fetching goals: ${error.message}`;
          console.error("Error fetching goals:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openAddModal() {
      this.editingGoal = null;
      this.showModal = true;
    },
    openEditModal(goal) {
      this.editingGoal = goal;
      this.showModal = true;
    },
    openImportModal() {
      this.showImportModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editingGoal = null;
    },
    onGoalSaved() {
      this.fetchGoals();
      this.closeModal();
    },
    onGoalsImported() {
      this.fetchGoals();
    },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
